import { Link } from 'react-router-dom';
import { channels } from '@/mocks/movies';

export default function ChannelGrid() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            特色频道
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大特色频道，覆盖动作、科幻、古装、爱情、动画、纪录片等多种类型，满足个性化观影需求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {channels.map((ch) => (
            <Link
              key={ch.slug}
              to={`/category/${ch.slug}`}
              className="group relative bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200 transition-all duration-300"
            >
              <div
                className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: `${ch.color}20` }}
              >
                <i className={`${ch.icon} text-2xl`} style={{ color: ch.color }}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1 whitespace-nowrap">{ch.name}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{ch.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}